import logout from './logout';

export const verifyAuth = async (status, setUser, navigate) => {
  if (status === 401) {
    const { status } = await logout();
    if (status === 200) {
      setUser(null);
      return navigate('/');
    }
  }
};
